export default function preventDefault(e: any) {
  e.stopPropagation();
  e.preventDefault();
}
